import { computed, inject, Injectable } from "@angular/core";
import { TopNavAbstraction } from "@app/shared-core/abstractions/top-nav.abstraction";
import { ELocalizationLang } from "@app/shared-core/enums/localization-lang.enum";
import { AuthService } from "@app/shared/auth/services/auth.service";
import { SessionService } from "@app/shared/general/sessions/services/session.service";
import { UserService } from "@app/shared/users/users/services/user.service";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class TopNavService extends TopNavAbstraction {
  private authService = inject(AuthService);
  private userService = inject(UserService);
  private sessionService = inject(SessionService);

  public isSessionSwitched = computed(() => !!this.authService.verifiedSession()?.userSwitchedTo);
  public originalUser = computed(() => {
    const user = this.authService.originalUser();
    return user ? this.authService.buildUserModel(user) : null;
  });

  changeMyPreferredLang(lang: ELocalizationLang): Observable<boolean> {
    return this.userService.changeMyPreferredLang(lang).pipe(map(res => !!res));
  }
  undoMySessionSwitch(): Observable<boolean> {
    return this.sessionService.undoMySessionSwitch().pipe(map(session => !!session));
  }
}
